import React from 'react'

const ChevronIcon = () => {
	return (
		<svg width={15} height={9} viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M13.34.289c.89-.906 2.3.529 1.336 1.435L8.222 8.37c-.371.378-1.038.378-1.41 0L.283 1.724C-.607.818.804-.617 1.693.29L7.48 6.255 13.34.29z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ChevronIcon
